import Image from "../image/image.component";
import { CMBackArrow } from "./back-arrow.styles";

const BackArrow = ({style, handleBack, ...props}) => {
    return (
        <CMBackArrow onClick={handleBack} style={style} className="back-arrow" {...props}>
            <Image src={'arrow-left-circle.png'}/>
        </CMBackArrow>
    );
}

export default BackArrow;